import React, { FunctionComponent } from "react";
import { Grid, IconButton, makeStyles, Theme, Typography, useTheme } from "@material-ui/core";
import { IIconProps } from "../../../../../assets/icons/icon";
import { ArrowRightIcon } from "../../../../../assets/icons/arrows/arrow-right-icon";

interface IOverviewBlockStyleProps {
  labelColor: string;
}

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    border: `2px solid ${theme.palette.grey["100"]}`,
    borderRadius: 16,
    padding: theme.spacing(4),
  },
  header: {
    fontWeight: 700,
    fontSize: 18,
    whiteSpace: "break-spaces",
  },
  labelContainer: {
    marginTop: theme.spacing(2),
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
    borderRadius: theme.spacing(1),
    backgroundColor: ({ labelColor }: IOverviewBlockStyleProps) => labelColor,
  },
  label: {
    fontSize: 15,
    fontWeight: 700,
    color: "white",
  },
  hero: {
    width: "100%",
  },
  graphicContainer: {
    position: "relative",
    width: "60px",
    height: "60px",
  },
  progressBg: {
    position: "absolute",
    height: "100%",
    color: "white",
  },
  iconButton: {
    height: 20,
    width: 20,
    backgroundColor: theme.palette.grey["200"],
    borderRadius: 4,
    "&.Mui-disabled": {
      backgroundColor: theme.palette.grey["200"],
      cursor: "not-allowed",
      pointerEvents: "all !important",
    },
    "& .MuiIconButton-root:hover": {
      backgroundColor: theme.palette.grey["200"],
    },
    "& .MuiIconButton-label": {
      width: 15,
    },
  },
}));

interface IOverviewProps {
  icon: FunctionComponent<IIconProps>;
  name: string;
  label: string;
  labelColor: string;
  onClick?: () => void;
  buttonDisabled?: boolean;
}

export const OverviewTolerance: FunctionComponent<IOverviewProps> = (props) => {
  const theme = useTheme();
  const { name, icon, label, labelColor, onClick, buttonDisabled } = props;
  const classes = useStyles({ labelColor });
  const IconComponent = icon;

  return (
    <Grid container className={classes.container}>
      <Grid item container justify={"space-between"} xs={12}>
        <Grid item xs={"auto"}>
          {onClick && (
            <IconButton className={classes.iconButton} onClick={onClick} disabled={buttonDisabled}>
              <ArrowRightIcon width={15} />
            </IconButton>
          )}
        </Grid>

        <Grid item className={classes.graphicContainer} xs={"auto"}>
          <IconComponent fill={theme.palette.primary.main}>{name}</IconComponent>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Grid item xs={12}>
          <Typography className={classes.header}>{name}</Typography>
        </Grid>
        <Grid item container xs={12} className={classes.labelContainer} justify="center" alignContent="center">
          <Typography className={classes.label}>{label}</Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};
